import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";

import styles from "./OffersPagination.module.scss";

export interface OffersPaginationProps {
  page: number;

  pageCount: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export const OffersPagination = ({
  page,
  pageCount,
  onPageChange,
  className,
}: OffersPaginationProps) => {
  const [block, cn] = useModuleBEM(styles, "OffersPagination");
  const { t } = useI18nContext();

  if (pageCount < 1) {
    return null;
  }

  const goTo = (next: number) => {
    const clamped = Math.min(Math.max(next, 1), pageCount);
    if (clamped !== page) {
      onPageChange(clamped);
    }
  };

  return (
    <nav
      className={clsx(block, className)}
      aria-label={t("hotelFundedOffersPage.pagination.label")}
    >
      <div className={cn("group")}>
        <button type="button" className={cn("link")} onClick={() => goTo(1)}>
          {t("hotelFundedOffersPage.pagination.first")}
        </button>
        <button
          type="button"
          className={cn("control")}
          onClick={() => goTo(page - 1)}
          aria-label={t("hotelFundedOffersPage.pagination.previous")}
        >
          <Icon iconName={IconNameEnum.leftNavChevron} useCurrentColor />
        </button>
      </div>

      <span className={cn("indicator")}>
        {t("hotelFundedOffersPage.pagination.pageOf", {
          page,
          total: pageCount,
        })}
      </span>

      <div className={cn("group")}>
        <button
          type="button"
          className={cn("control")}
          onClick={() => goTo(page + 1)}
          aria-label={t("hotelFundedOffersPage.pagination.next")}
        >
          <Icon iconName={IconNameEnum.rightNavChevron} useCurrentColor />
        </button>
        <button
          type="button"
          className={cn("link")}
          onClick={() => goTo(pageCount)}
        >
          {t("hotelFundedOffersPage.pagination.last")}
        </button>
      </div>
    </nav>
  );
};
